import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisation OrganisationModel
 * @param requestedPage number
 * @param numberOfItemsPerPage number
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisation, requestedPage, numberOfItemsPerPage) {
    if (requestedPage === void 0) { requestedPage = 1; }
    if (numberOfItemsPerPage === void 0) { numberOfItemsPerPage = 10; }
    var url = applyPathVariables(EndPoints.SERVICE_ENTRIES_CLOSED_PAGINATED, {
        organisationId: organisation.id, requestedPage: requestedPage, numberOfItemsPerPage: numberOfItemsPerPage
    });
    var headers = { 'Content-Type': 'application/json' };
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true, headers: headers });
    return request.execute();
});
